import { createStyles, Flex, Skeleton } from "@mantine/core";
import React from "react";

const useStyles = createStyles((theme) => ({
  loader: {
    height: "30vh",
    width: "100%",
    paddingTop: 50,
  },
  text: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#000",
  },
}));
function RemainingCounts({ text, count, loadingCount = false }) {
  const { classes } = useStyles();
  return (
    <div className={classes?.text}>
      <Flex align="center" gap={5}>
        {text} : {loadingCount ? <Skeleton height={20} width={20} mt={5}/> : count}
      </Flex>
    </div>
  );
}

export default RemainingCounts;
